<template>
  <gat-dialog
    v-model="dialogVisible"
    :cancelButtonCaption="noAction ? '' : 'CLOSE'"
    :okButtonCaption="noAction ? '' : 'OPEN EMAIL'"
    width="600"
    @okClick="goToEmail()"
    @cancelClick="close()"
    :okButtonDisabled="OkDisabled">
    <v-stepper :value="docStatus" class="elevation-0">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="docStatus > 0">Added to queue</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="docStatus > 1">Generation started</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step v-if="docStatus <= 3" step="3" :complete="docStatus > 2">Email ready</v-stepper-step>
        <v-stepper-step
          v-if="docStatus == 4"
          step="3"
          :complete="docStatus > 2"
          complete-icon="mdi-close-circle-outline"
          color="red"
          ><span style="color: red">Generation failed</span></v-stepper-step
        >
      </v-stepper-header>
    </v-stepper>

    <span v-if="docStatus < 3">Your email should be ready in a few seconds.</span>
    <div v-else-if="docStatus == 3" class="ml-5">Email is ready {{ doc.TITLE }}</div>
    <span v-else-if="docStatus == 4" class="ml-5">
      <span>Something went wrong with the email generation.</span>
    </span>
  </gat-dialog>
</template>

<script>
import { apiGet } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';
import { getEmailGenerationStatus } from '@/services/api/api-calls/getEmailGenerationStatus';

export default {
  name: 'EmailStatus',
  props: {
    guid: {
      type: String,
    },
    showForm: {
      type: Boolean,
      default: false,
    },
    // If no action is needed from the user.
    noAction: Boolean,
    managedGeneration: Boolean,
  },
  components: {},
  setup() {
    const applicationStore = useApplicationStore();
    return {
      applicationStore,
    };
  },
  data() {
    return {
      dialogVisible: this.showForm,
      docStatus: 0,
      statusTimer: undefined,
      statusRequestId: 0,
      doc: { FILENAME: 'Proforma with vouchers.pdf' },
    };
  },

  computed: {
    OkDisabled() {
      return this.docStatus !== 3;
    },
  },

  mounted() {
    this.dialogVisible = this.showForm;
  },

  beforeDestroy() {
    this.stopPolling();
  },

  watch: {
    showForm(newValue) {
      this.dialogVisible = newValue;
    },
    guid: {
      immediate: true,
      handler(newValue) {
        this.stopPolling();
        this.docStatus = 0;
        this.doc = {};
        if (newValue) this.checkStatus();
      },
    },
  },

  methods: {
    stopPolling() {
      clearTimeout(this.statusTimer);
      this.statusTimer = undefined;
      this.statusRequestId += 1;
    },
    async checkStatus() {
      this.stopPolling();
      const { guid, statusRequestId } = this;
      if (!guid) return;
      try {
        const data = this.managedGeneration
          ? await getEmailGenerationStatus(guid)
          : await apiGet(`document/status/${guid}`);
        if (guid !== this.guid || statusRequestId !== this.statusRequestId) return;
        this.docStatus = data?.DQU_QUEUE_STATUS || 0;
        if (this.applicationStore.debugMode) {
          console.log(this.docStatus);
        }
        if (this.docStatus < 3) {
          this.statusTimer = setTimeout(this.checkStatus, 2000);
        } else {
          if (this.docStatus == 3) {
            this.doc = { TITLE: data.TITLE, ID: data.DQU_DOCUMENT_ID };
            this.$emit('documentCreated', this.doc);
            if (this.noAction) {
              this.statusTimer = setTimeout(() => {
                this.dialogVisible = false;
              }, 2000);
            }
          }
          if (!this.dialogVisible) {
            this.$emit('documentReady', this.doc);
          }
        }
      } catch (error) {
        if (guid !== this.guid || statusRequestId !== this.statusRequestId) return;
        if ([400, 403, 404].includes(error.response?.status)) {
          this.docStatus = 4;
        } else {
          this.statusTimer = setTimeout(this.checkStatus, 2000);
        }
      }
    },
    close() {
      this.$emit('close');
    },

    goToEmail() {
      if (this.OkDisabled) return;
      this.close();
      this.$emit('goToEmailClicked', this.doc.ID);
    },
  },
};
</script>

<style scoped></style>
